import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

/**
 * MUI Components
 */
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

const WorkActionSubareaControl = ({ list, value, handleChange }) => {
    const { t } = useTranslation();
    const [localValue, setLocalValue] = useState(value);
    const previousValue = useRef(value);

    // Reset localValue when value changes (including when zone changes)
    useEffect(() => {
        // Only update if the value has actually changed
        if (previousValue.current !== value) {
            setLocalValue(value);
            previousValue.current = value;
        }
    }, [value]);

    const handleLocalChange = (event) => {
        const newValue = event.target.value;
        setLocalValue(newValue);
        handleChange(event);
    };

    return (
        <FormControl fullWidth>
            <InputLabel id="select-action-subarea-label">{t('Action subarea')}</InputLabel>
            <Select
                labelId="select-action-subarea-label"
                id="select-action-subarea"
                name="selectActionSubarea"
                value={localValue}
                onChange={handleLocalChange}
                label={t('Action subarea')}
                required
                disabled={list.length === 0} // Disable if no options
            >
                <MenuItem key={0} value={0}>
                    {t('No subzone')}
                </MenuItem>
                {list.map((area) => (
                    <MenuItem key={area.id} value={area.id}>
                        {area.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

WorkActionSubareaControl.propTypes = {
    value: PropTypes.number,
    list: PropTypes.array.isRequired,
    handleChange: PropTypes.func.isRequired,
};

export default WorkActionSubareaControl;
